import type { LensSpace } from '~/types/leLens';

/** Main team, all server-backed pins, then other member teams by name. */
export function rankTeams(spaces: Array<LensSpace>, viewerEmail?: string | null): Array<LensSpace> {
  const email = viewerEmail?.trim().toLowerCase();
  return spaces
    .map((space) => ({
      ...space,
      isMember: space.isMember ?? Boolean(space.role || (email && space.members?.some((member) => member.email.toLowerCase() === email))),
    }))
    .filter(
      (space) =>
        !space.archivedAt &&
        (Boolean(space.pinOrder) || space.main || space.isMember),
    )
    .sort((a, b) => {
      const order = (space: LensSpace) => (space.main ? 0 : space.pinOrder ? 1 : 2);
      return order(a) - order(b) || (a.pinOrder ?? 0) - (b.pinOrder ?? 0) || a.name.localeCompare(b.name);
    });
}
